var React = require('react');

function Statistic (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.625 35.8474L21.125 19.32L32.125 30.3199L55.5 4.02996L51.6225 0.152466L32.125 22.0699L21.125 11.07L0.5 31.7224L4.625 35.8474Z","fill":"#1008BD"}));
}

Statistic.defaultProps = {"width":"56","height":"36","viewBox":"0 0 56 36","fill":"none"};

module.exports = Statistic;

Statistic.default = Statistic;
